/* SBI CUSTOM - QuickStudy Guides: format toggle, topic chips, quick add, calculators, shop-by-topic. Loaded with defer. */
(function () {
  if (window.__sbiQs) return;
  window.__sbiQs = true;
  var money = function (cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  function toast(root, msg) {
    var t = root.querySelector('[data-qs-toast]');
    if (!t) return;
    t.innerHTML = msg + ' <a href="/cart">View cart</a>';
    t.hidden = false;
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.hidden = true; }, 4200);
  }

  function refreshCount() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-js-cart-count]').forEach(function (el) { el.innerHTML = c.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } }));
    }).catch(function () {});
  }

  function add(items) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); });
  }

  /* ---------- collection landing ---------- */
  var root = document.querySelector('[data-qs-root]');
  if (root) {
    var setFormat = function (f) {
      root.setAttribute('data-format', f);
      root.querySelectorAll('[data-qs-format]').forEach(function (b) {
        var on = b.getAttribute('data-qs-format') === f;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
      });
      root.querySelectorAll('[data-href-' + f + ']').forEach(function (a) { a.href = a.getAttribute('data-href-' + f); });
      store.set('sbiQsFormat', f);
    };
    var q = new URLSearchParams(location.search).get('format');
    var start = q === 'pdf' || q === 'pack' ? q : store.get('sbiQsFormat');
    if (start === 'pdf') setFormat('pdf');

    root.addEventListener('click', function (e) {
      var f = e.target.closest('[data-qs-format]');
      if (f) { setFormat(f.getAttribute('data-qs-format')); return; }
      var g = e.target.closest('[data-qs-group]');
      if (g) {
        var key = g.getAttribute('data-qs-group');
        root.querySelectorAll('[data-qs-group]').forEach(function (c) { c.classList.toggle('is-on', c === g); });
        root.querySelectorAll('[data-qs-grid] .qs-card').forEach(function (card) {
          card.classList.toggle('is-hidden', key !== 'all' && card.getAttribute('data-group') !== key);
        });
        return;
      }
    });
  }

  /* ---------- quick add buttons (collection + anywhere) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.sbi-qs [data-qs-add]');
    if (!b || b.disabled) return;
    var host = b.closest('.sbi-qs');
    var label = b.textContent;
    b.disabled = true; b.textContent = 'Adding...';
    add([{ id: +b.getAttribute('data-qs-add'), quantity: 1 }]).then(function () {
      b.classList.add('is-done'); b.textContent = 'Added';
      toast(host, 'Added to cart.');
      refreshCount();
      setTimeout(function () { b.classList.remove('is-done'); b.textContent = label; b.disabled = false; }, 2200);
    }).catch(function (err) {
      b.textContent = label; b.disabled = false; toast(host, err.message);
    });
  });

  /* ---------- rack calculator (collection) ---------- */
  document.querySelectorAll('[data-qs-calc]').forEach(function (c) {
    var factor = parseFloat(c.getAttribute('data-factor')) || 1;
    if (c.getAttribute('data-guest') === '1') factor = 0.5;
    var inp = function (k) { return c.querySelector('[data-qs-in="' + k + '"]'); };
    var out = function (k, v) { var el = c.querySelector('[data-qs-out="' + k + '"]'); if (el) el.textContent = v; };
    var run = function () {
      var topics = +inp('topics').value, deep = +inp('deep').value, guides = topics * deep * 5;
      var retail = guides * 1000, cost = retail * factor;
      out('topics', topics); out('deep', deep); out('guides', guides);
      out('cost', money(cost)); out('retail', money(retail)); out('profit', money(retail - cost));
    };
    c.addEventListener('input', run); run();
  });

  /* ---------- PDF cost-per-copy (product page) ---------- */
  document.querySelectorAll('[data-qs-pdfcalc]').forEach(function (c) {
    var price = parseFloat(c.getAttribute('data-price')) || 0;
    var run = function () {
      var n = Math.max(1, +c.querySelector('[data-qs-in="copies"]').value);
      var pr = Math.max(0, parseFloat(c.querySelector('[data-qs-in="print"]').value) || 0);
      c.querySelector('[data-qs-out="copies"]').textContent = n;
      c.querySelector('[data-qs-out="per"]').textContent = money(price / n + pr * 100);
    };
    c.addEventListener('input', run); run();
  });

  /* ---------- flip viewer (product page) ---------- */
  document.addEventListener('click', function (e) {
    var f = e.target.closest('[data-qs-flip]');
    if (f) f.closest('[data-qs-viewer]').classList.toggle('is-flipped');
  });

  /* ---------- shop by topic ---------- */
  var pk = document.querySelector('[data-qs-picker]');
  if (pk) {
    var dockBtn = pk.querySelector('[data-qs-addall]');
    var sum = function () {
      var n = 0, t = 0;
      pk.querySelectorAll('[data-qs-row]').forEach(function (r) {
        var i = r.querySelector('[data-qs-qty]'); if (!i) return;
        var q = Math.max(0, parseInt(i.value, 10) || 0);
        var max = parseInt(r.querySelector('.qs-step').getAttribute('data-max'), 10);
        if (max >= 0 && q > max) { q = max; i.value = q; }
        r.classList.toggle('is-picked', q > 0);
        n += q; t += q * parseFloat(r.getAttribute('data-price'));
      });
      pk.querySelector('[data-qs-count]').textContent = n;
      pk.querySelector('[data-qs-total]').textContent = money(t);
      dockBtn.disabled = n === 0;
    };
    pk.addEventListener('click', function (e) {
      var inc = e.target.closest('[data-qs-inc]'), dec = e.target.closest('[data-qs-dec]');
      if (inc || dec) {
        var i = (inc || dec).parentNode.querySelector('[data-qs-qty]');
        i.value = Math.max(0, (parseInt(i.value, 10) || 0) + (inc ? 1 : -1));
        sum();
      }
    });
    pk.addEventListener('input', sum);
    dockBtn.addEventListener('click', function () {
      var items = [];
      pk.querySelectorAll('[data-qs-row]').forEach(function (r) {
        var i = r.querySelector('[data-qs-qty]'); var q = i ? parseInt(i.value, 10) || 0 : 0;
        if (q > 0) items.push({ id: +r.getAttribute('data-id'), quantity: q });
      });
      if (!items.length) return;
      dockBtn.disabled = true; dockBtn.textContent = 'Adding...';
      add(items).then(function () {
        pk.querySelectorAll('[data-qs-qty]').forEach(function (i) { i.value = 0; });
        sum(); toast(pk, 'Added ' + items.length + ' topics to your cart.'); refreshCount();
        dockBtn.textContent = 'Add to cart';
      }).catch(function (err) { dockBtn.textContent = 'Add to cart'; dockBtn.disabled = false; toast(pk, err.message); });
    });
    sum();
  }
})();
